export function createOgImage(url: string, alt: string) {
	return {
		url,
		width: 1200,
		height: 630,
		alt,
	};
}
